import React, { useState } from 'react';
import axios from 'axios';
import {
  Form,
  FormGroup,
  FormLabel,
  FormControl,
  Button,
  Image,
  Row,
  Col
} from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import config from '../config/config';
import { useAuth } from '../contexts/AuthContext';
import { useResto } from '../contexts/RestoContext';
import { useWebsite, setFlashMessage } from '../contexts/WebsiteContext';
import { ucfirst } from '../utils/utils';

const FaqAddItem = ({ handleAddItem }) => {
  const { t } = useTranslation();
  const { token } = useAuth();
  const { restoData } = useResto();
  const { setIsLoading } = useWebsite();

  // ✅ SAFE fallback
  const availableLanguages = restoData?.availableLanguages || [];

  const defaultFormData = {
    website: restoData?.website || '',
    questionFr: '',
    questionEn: '',
    questionDe: '',
    questionEs: '',
    answerFr: '',
    answerEn: '',
    answerDe: '',
    answerEs: '',
  };

  const [formData, setFormData] = useState(defaultFormData);

  const handleChange = e => {
    const { name, value } = e.target;

    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const resetFormData = () => {
    setFormData(defaultFormData);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      await axios.post(
        `${config.apiUrl}faq`,
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`
          }
        }
      );

      setFlashMessage(t('SUCCESS_CREATED_MESSAGE'), 'success');
      handleAddItem();
      resetFormData();

    } catch (error) {
      setFlashMessage(t('ERROR_MESSAGE'), 'error');
    }

    setIsLoading(false);
  };

  const renderInputFields = (language) => {
    return (
      <>
        <FormGroup>
          <FormLabel htmlFor={`question${ucfirst(language)}`}>
            Question{' '}
            <Image
              src={`${config.kubuniImagesUrl}general-icons/flag_${language}_icon_24.png`}
              className="flag-label"
              alt={`Question ${language}`}
            />
          </FormLabel>

          <FormControl
            type="text"
            id={`question${ucfirst(language)}`}
            name={`question${ucfirst(language)}`}
            value={formData[`question${ucfirst(language)}`]}
            onChange={handleChange}
            required
          />
        </FormGroup>

        <FormGroup>
          <FormLabel htmlFor={`answer${ucfirst(language)}`}>
            Réponse{' '}
            <Image
              src={`${config.kubuniImagesUrl}general-icons/flag_${language}_icon_24.png`}
              className="flag-label"
              alt={`Answer ${language}`}
            />
          </FormLabel>

          <FormControl
            as="textarea"
            rows={3}
            id={`answer${ucfirst(language)}`}
            name={`answer${ucfirst(language)}`}
            value={formData[`answer${ucfirst(language)}`]}
            onChange={handleChange}
            required
          />
        </FormGroup>
      </>
    );
  };

  return (
    <div>
      <div className="p-3">
        <Form onSubmit={handleSubmit}>
          <Row className="margin-top-20">
            {availableLanguages.map((language, index) => (
              <Col key={language || index}>
                {renderInputFields(language)}
              </Col>
            ))}
          </Row>

          <div
            className="text-center margin-top-20"
            style={{ marginBottom: '60px' }}
          >
            <Button type="submit">
              {t('ADD')}
            </Button>
          </div>
        </Form>
      </div>
    </div>
  );
};

export default FaqAddItem;